import { motion } from 'framer-motion'
import styled, { css } from 'styled-components'
import IconLeft from '~/assets/images/left.png'
import IconModalCloseDark from '~/assets/images/x.png'

export const StyledBoxContainer = styled.div``

export const StyledSingleBoxContainer = styled(StyledBoxContainer)`
  padding-top: 145px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 600px) {
    box-sizing: border-box;
    padding: 10px;
    padding-top: 0px;
    width: 100%;
    height: 100%;
  }
`

export const StyledBox = styled.div`
  background-color: ${({ theme }) => theme.colors.bgCard};
  border-radius: 16px;
  overflow: hidden;
  width: 85vw;
  height: auto;
  min-width: 435px;
  margin: 0 auto 15px;
  max-width: 435px;
  border: 0.5px solid ${({ theme }) => theme.colors.borderBrand};

  @media screen and (max-width: 600px) {
    width: 100%;
    min-width: 100%;
  }
`

export const StyledSingleBox = styled(StyledBox)`
  min-height: 433px;
`

export const StyledRootBox = styled.div`
  background: ${({ theme }) => theme.colors.bgCard};
  padding: 20px;
  position: relative;

  &.hide-root {
    display: none;
  }
`

export const StyledSubsetBox = styled(motion.div)<{ icon: string | null }>`
  height: 100%;
  min-height: 400px;

  &.hide {
    display: none;
    opacity: 0;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: ${({ theme }) => theme.colors.bgCard};
    }
  }

  .title {
    padding: 12px 10px;
    display: flex;
    box-shadow: inset 0px -1px 0px ${({ theme }) => theme.colors.borderSubtle};
    align-items: center;
    justify-content: center;
  }
  .title span {
    text-align: center;
    justify-content: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    flex: 1;
    padding: 0 12px;
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
    ${({ icon }) =>
      icon &&
      css`
        margin-left: -24px;
      `}
  }
  .icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
    z-index: 1;
    background-color: transparent;
    transition: background-color ease-in-out 0.2s;
    border-radius: 8px;
  }
  .icon::after {
    content: '';
    width: 24px;
    height: 24px;
    display: inline-block;
    background-repeat: no-repeat;
    background-size: contain;
  }
  .icon:hover.icon {
    background-color: ${({ theme }) => theme.colors.bgSurface};
  }
  .icon-back::after {
    background-image: url(${IconLeft.src});
  }
  .icon-close::after {
    background-image: url(${IconModalCloseDark.src});
  }

  .settingsModal {
    min-height: 430.5px;
    padding: 0 20px;
  }
`
